import { type RootState } from "@/store";

export const getPlanTypeFromStore = (state: RootState) => state.planType;
export const getCurrentPlanType = (state: RootState) => state.planType;
export const getPendingUpgrade = (state: RootState) => state.pendingUpgrade;
export const getCheckoutSource = (state: RootState) => state.checkoutSource;
// computed/Derived selectors
export const isUpgradeFlow = (state: RootState) =>
  Boolean(state.planType.pendingUpgrade);
export const isNewPurchaseFlow = (state: RootState) =>
  state.planType.checkoutSource === "verifyToken";
export const hasActiveCheckout = (state: RootState) =>
  Boolean(state.planType.checkoutSource);
export const getTargetPlanType = (state: RootState) =>
  state.planType.pendingUpgrade || state.planType.planType || "studentPlan";
export const isStudentPlan = (state: RootState) =>
  state.planType.planType === "studentPlan";
export const isTeacherPlan = (state: RootState) =>
  state.planType.planType === "teacherPlan";
/**
 * Entitlement check — must read from auth.user (server truth), never from
 * planType.planType (see the slice's doc comment). planType.planType is
 * persisted (redux-persist) and only moves on purchase-flow actions, so it
 * can silently drift away from "studentPlan" for a real student (stale
 * persisted state, an aborted flow) with nothing to resync it. That drift
 * made canUpgrade false for genuine students, and RequireUnpaid bounced
 * them straight back to /courses on "Proceed" instead of into the funnel.
 */
export const canUpgradeToTeacher = (state: RootState) =>
  state.auth.user?.role === "student";
